import { render, staticRenderFns } from "./TextAreaToggleExpand.vue?vue&type=template&id=dd611d2a&scoped=true&"
import script from "./TextAreaToggleExpand.vue?vue&type=script&lang=ts&"
export * from "./TextAreaToggleExpand.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaToggleExpand.vue?vue&type=style&index=0&id=dd611d2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd611d2a",
  null
  
)

export default component.exports